import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="crypto" id="crypto"></a>
    <h1 {...{
      "id": "windowcrypto"
    }}>{`window.crypto`}</h1>
    <p><strong parentName="p">{`See`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/API/Crypto"
        }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Crypto`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://w3c.github.io/webcrypto/#Crypto-method-getRandomValues"
        }}>{`https://w3c.github.io/webcrypto/#Crypto-method-getRandomValues`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://w3c.github.io/webcrypto/#Crypto-method-randomUUID"
        }}>{`https://w3c.github.io/webcrypto/#Crypto-method-randomUUID`}</a></li>
    </ul>
    <p><strong parentName="p">{`Since`}</strong>{`: UXP v6.2  `}</p>
    <a name="crypto-getrandomvalues" id="crypto-getrandomvalues"></a>
    <h2 {...{
      "id": "getrandomvaluesarray"
    }}>{`getRandomValues(array)`}</h2>
    <p>{`Generates cryptographically strong random values`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: The same array passed as 'array' but with its contents replaced with the newly generated random numbers`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TypedError`}</inlineCode>{` If the input 'array' is not a TypedArray or either Float32Array or Float64Array`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` If the input 'array' length exceeds 65,536 bytes`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`IntegerArray`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An integer-based TypedArray, that is one of Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, BigInt64Array, BigUint64Array but not Float32Array nor Float64Array`}</td>
        </tr>
      </tbody>
    </table>
    <a name="crypto-randomuuid" id="crypto-randomuuid"></a>
    <h2 {...{
      "id": "randomuuid"
    }}>{`randomUUID()`}</h2>
    <p>{`Generates a new version 4 UUID`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - String containing a randomly generated, 36 character long v4 UUID  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      